import {displayError} from '../app/errorDisplayer';
import ErrorDialog from '../fw/ErrorDialog.react';

export default function mutationError(transaction, display = true) {
    let error;
    let isDativeryError = false;
    let originalError = {};

    try {
        error = transaction.getError();
    }
    catch (e) {}

    try {
        originalError = JSON.parse(error.res.payload.errors[0].message || '{}');
        isDativeryError = originalError.dativeryError === true;
    }
    catch (e) {
        isDativeryError = false;
    }

    if (isDativeryError) {
        ErrorDialog(originalError);
    }
    else {
        console.log(transaction); // eslint-disable-line no-console
        error = error || new Error('Mutation failed.');
        console.error(error); // eslint-disable-line no-console

        if (display) {
            displayError(error);
        }
    }

    return error;
}
